import { render, staticRenderFns } from "./OverallTotalMembers.vue?vue&type=template&id=5f4b2d48&"
import script from "./OverallTotalMembers.vue?vue&type=script&lang=js&"
export * from "./OverallTotalMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports